import { useCallback, useEffect, useState } from "react";
import MenuTop from "../../../../components/menu/top/menu-top";
import './style.css';
import { FormProps } from "../../../../shared/interfaces/form";
import Form from "../../../../components/form/form";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { useNavigate } from 'react-router-dom';
import { createUserService } from "../../../../features/users/service/users-service";
import { fetchRolesWithoutAdmin } from "../../../../shared/services/roles";
import userData from "../../../../features/users/forms/user-data";
import storage from "../../../../shared/services/storage";
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import { fetchCompaniesService as getCompanies } from "../../../../features/company/service/company";
import InfoComponent from "../../../../components/info/info";

export function AddUser() {
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<FormProps[] | undefined>();

    const handleCreateUser = async (formData: any) => {
        if(!formData) {
            showAlert('Dados inválidos', SEVERITY.ERROR);
            return;
        }

        const user = JSON.parse(storage.getStorage('user') || '');
        
        if(formData) {
            formData.firstAcess = true;

            if(!!user?.name && user?.name.toLowerCase() !== 'cauane') {
                formData.companyId = user?.company.id;
            }

            const response = await createUserService(formData);

            if(response) {
                showAlert('Usuário criado com sucesso', SEVERITY.SUCCESS);
                navigate('/usuarios');
            } 

            if(!response) {
                showAlert('Erro ao criar usuário', SEVERITY.ERROR);
            }
        }
    };

    const fetchRolesData = useCallback(async () => {
        try {
            const roles = await fetchRolesWithoutAdmin();
            console.log('fetch Roles' , roles);
            const companies = await getCompanies();
            const rolesOptions = roles?.map(({ name, id}: any) => ({ label: name, value: id }));
            const user = JSON.parse(storage.getStorage('user') || '');

            const isMaster = user?.name.toLowerCase() === 'cauane';

            const data = userData(undefined, undefined, rolesOptions, isMaster, companies);
            setFormData(data);
        } catch (error) {
            console.log(error);
        }
    }, []);


    useEffect(() => {
        fetchRolesData();
    }, [fetchRolesData]);

    return (
        <div className="container-client">
            <MenuTop />
            <div className='container-client__content'>
                <Breadcrumb links={['Usuários', 'Adicionar usuário']} href={['/usuarios', '']} />
                {formData && (
                    <>
                        <InfoComponent />
                        <Form
                            data={formData}
                            onSubmitForm={handleCreateUser}
                            onCancel={() => navigate('/usuarios')}
                            title="Adicionar usuário"
                        />
                    </>
                )}
            </div>
        </div>
    );
}